import React from 'react';
import { Link } from 'react-router-dom';
import Brand from './Brand';
export default function SiteFooter() {
  return <footer className="korean-footer"><div className="korean-container korean-footer-inner"><Link to="/" aria-label="Korean Lash Lift by Ali — accueil"><Brand /></Link><p>Le soin du regard.<br />La signature d’Ali.</p><div><Link to="/tarifs">Prestations & tarifs</Link><Link to="/galerie">Nos réalisations</Link><Link to="/connexion">Mon espace</Link></div><span>© {new Date().getFullYear()}<br />Korean Lash Lift by Ali</span></div></footer>;
}
